module.exports = __webpack_public_path__ + "img/8.08f4caa1.png";